import { HttpClient } from '@angular/common/http';
import { AppStateFacade } from '@app-state';
import { ReplaySubject, } from 'rxjs';
import { map } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../app-state/app-state.facade";
var LanguageService = /** @class */ (function () {
    function LanguageService(_http, _appState) {
        this._http = _http;
        this._appState = _appState;
        this._endpoint = 'odata/Settings';
        this._hasSentRequest = false;
        this._languages$ = new ReplaySubject(1);
    }
    LanguageService.prototype.getAll = function () {
        var _this = this;
        if (!this._hasSentRequest) {
            this._http.get(this._endpoint + "/UiPath.Server.Configuration.OData.GetLanguages?v=\n            " + this._appState.authConfig.buildVersion)
                .pipe(map(function (result) {
                return result.Items;
            }))
                .subscribe(function (languages) {
                _this._languages$.next(languages);
                _this._languages$.complete();
            }, function (error) {
                error.isSeed = true;
                throw error;
            });
            this._hasSentRequest = true;
        }
        return this._languages$;
    };
    LanguageService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LanguageService_Factory() { return new LanguageService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.AppStateFacade)); }, token: LanguageService, providedIn: "root" });
    return LanguageService;
}());
export { LanguageService };
